/*
 * @Author: wangqi angelqiqiwang@shjinjia.com.cn
 * @Date: 2024-08-15 16:42:21
 * @LastEditors: yangtao yangtao123
 * @LastEditTime: 2024-08-19 10:41:59
 * @FilePath: \oak\src\store\modules\routerMap\views\financeAccounting.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
const map = {
  accountingVoucher: () => import('@/views/financeAccounting/AccountingVoucher'), // 预计账列表
  nCVoucherAccount: () => import('@/views/financeAccounting/NCVoucherAccount'), // 记账数据列表
  nCVoucherTemplate: () => import('@/views/financeAccounting/NCVoucherTemplate'), // 模板列表
  nCVoucherTemplateDetail: () => import('@/views/financeAccounting/NCVoucherTemplate/Detail') // 模板详情
}

export default map
